import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import type { RowAction, ActionItem, ActionGroup } from "./types";
import { getHandler } from "./actions";

function ActionItemEl({ item, row }: { item: ActionItem; row: Record<string, any> }) {
  if (item.handler) {
    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault();
      const handler = getHandler(item.handler!);
      handler({
        source: "row_action",
        actionName: item.handler!,
        selectedRows: [row],
        optionValues: {},
        config: item.handler_config,
      });
    };

    return (
      <Dropdown.Item
        href="#"
        onClick={handleClick}
        disabled={item.disabled}
        className="lt-action-item"
      >
        <i className={`${item.icon} lt-action-item__icon`} />
        {item.title}
      </Dropdown.Item>
    );
  }

  return (
    <Dropdown.Item
      href={item.url}
      disabled={item.disabled}
      className="lt-action-item"
      {...(item.download ? { download: "" } : {})}
    >
      <i className={`${item.icon} lt-action-item__icon`} />
      {item.title}
    </Dropdown.Item>
  );
}

function ActionGroupEl({ group, row }: { group: ActionGroup; row: Record<string, any> }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="lt-submenu"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button type="button" className="dropdown-item lt-action-item lt-submenu__trigger">
        <i className="fas fa-chevron-left lt-submenu__arrow" />
        <i className={`${group.icon} lt-action-item__icon`} />
        {group.title}
      </button>
      {open && (
        <div className="lt-submenu__menu lt-dots-menu">
          {group.children.map((child, i) => (
            <ActionItemEl key={i} item={child} row={row} />
          ))}
        </div>
      )}
    </div>
  );
}

export default function RowActions({ actions, row, dropUp }: { actions: RowAction[]; row: Record<string, any>; dropUp?: boolean }) {
  if (!actions || actions.length === 0) return null;

  return (
    <Dropdown align="end" drop={dropUp ? "up" : "down"}>
      <Dropdown.Toggle as="button" className="lt-dots-btn" bsPrefix=" ">
        <i className="fas fa-ellipsis-h" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="lt-dots-menu" renderOnMount popperConfig={{ strategy: "fixed" }}>
        {actions.map((action, i) =>
          action.type === "group" ? (
            <ActionGroupEl key={i} group={action as ActionGroup} row={row} />
          ) : (
            <ActionItemEl key={i} item={action as ActionItem} row={row} />
          )
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
